export default "__VITE_ASSET__BjQDsd1z__"